import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';

class CommonDemoModalStore extends BaseModalStore {


  @observable expandVideoUrl = '';
  @observable closeCallback = noop;
  @observable isOpen = false;
  @observable historyImg = 1;
   // 机甲主store
   @observable mechaStore;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
  };

  use() {
    super.use();
  }
}

export default CommonDemoModalStore;
